
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections",
      function () {
        return require("private-next-pages/collections/index.js");
      }
    ]);
  